import React, { useState, useEffect } from "react";
import {
  Typography,
  Result,
  Spin,
  Card,
  Form,
  Button,
  Input,
  Image,
  Layout,
} from "antd";
import Utilities from "../dependencies/custom/react-utilities";
import { useNavigate, Link } from "react-router-dom";
import Settings from "../dependencies/custom/settings";
import { LoadingOutlined } from "@ant-design/icons";
import logo2 from "../../img/brand/brand.png";
import useWindowDimensions from "../hooks/screensize";
const { Content } = Layout;
const { Title } = Typography;
const PassportResetConfirm = () => {
  const { vpWidth, vpHeight } = useWindowDimensions();
  const isMobile = vpWidth <= 768;
  const navigate = useNavigate();
  const [spinning, setSpinning] = useState(true);
  const [isValidToken, setIsValidToken] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState();
  const [data, setData] = useState();
  useEffect(() => {
    const params = Utilities.getQString();
    setData(params);
    if ("token" in params) {
      validateToken(params);
    } else {
      setSpinning(false);
      setResult(
        <Result
          status="error"
          title={`Password Recovery Failed. Invalid URL`}
        />,
      );
    }
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    const d = { ...values, token: data?.token };
    const res = await Utilities.fetchWithAuth(
      "POST",
      Settings.urls.auth.passwordResetConfirm,
      d,
      navigate,
    );
    if (res.ok) {
      Utilities.showNotification(
        undefined,
        "Password has been reset successfully",
        "text-success",
      );
      navigate("../../signin", { replace: true });
    } else {
      Utilities.showNotification(undefined, res?.msg);
      navigate("../../signin", { replace: true });
    }
    setLoading(false);
  };

  function confPasswordPage() {
    return (
      <Layout className="layout-default ant-layout layout-sign-up">
        <Content className="p-0">
          <div
            className="sign-up-header mt-5x"
            style={{
              // backgroundImage: `url(${banner2})`,
              background: isMobile
                ? "transparent"
                : "linear-gradient(135deg, #1f1f5d, #00c9a7)",
              height: "300px",
              border: isMobile && "none",
              boxShadow: isMobile && "none",
            }}
          />
          <Card
            className="card-signup header-solid h-full ant-card pt-0"
            title={
              <div className="d-flexx justify-content-centerx">
                <div className="d-flex justify-content-center mt-3">
                  <Image
                    className="mb-2"
                    preview={false}
                    width={Settings?.logoWidth}
                    src={logo2}
                    alt=""
                  />
                </div>
                <div className="d-flex justify-content-center mb-5x text-center">
                  <Title
                    level={5}
                    className="fw-bold text-wrap text-dark"
                    style={{ maxWidth: "90%" }}
                  >
                    Hillside Schools – Naalya
                  </Title>
                </div>
              </div>
            }
            style={{ backgroundColor: "#fafafa" }}
          >
            <Form onFinish={onFinish} layout="vertical" className="row-col">
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>
              <Form.Item
                label="Confirm Password"
                name="password_confirm"
                dependencies={["password"]}
                hasFeedback
                rules={[
                  { required: true, message: "Please confirm your password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match!"),
                      );
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={loading}
                >
                  Set New Password
                </Button>
              </Form.Item>

              <p className="font-semibold text-muted">
                Remember Password?{" "}
                <Link to="/signin" className="text-muted font-bold">
                  Sign In
                </Link>
              </p>
            </Form>
          </Card>
        </Content>
      </Layout>
    );
  }

  async function validateToken(params) {
    const { token } = params || {};
    setSpinning(true);
    const res = await Utilities.fetchWithAuth(
      "POST",
      Settings?.urls?.auth?.validatePsdToken,
      { token },
      navigate,
      "../signin",
    );
    if (res.ok) {
      setIsValidToken(true);
    } else {
      setResult(
        <Result
          status="error"
          title={res.msg}
          subTitle={
            <div className="fw-bold h5">
              <Button type="primary">
                <Link to="/signin">Sign In</Link>
              </Button>
            </div>
          }
        />,
      );
    }
    setSpinning(false);
  }

  return (
    <>
      {isValidToken ? confPasswordPage() : result}
      <Spin
        indicator={<LoadingOutlined />}
        style={{ fontSize: 48 }}
        spinning={spinning}
        fullscreen
      />
    </>
  );
};
export default PassportResetConfirm;
